import React from 'react'
import "./Spinner.css";

const Spinner = () => {
  return (
    <div className="flex flex-col justify-center items-center min-h-[80vh]">
        <div className='spinner'></div>
    </div>
  )
}

export default Spinner